<template>
	<button class="v-editor-link" @click="insert" :disabled="disabled">链接</button>
</template>

<script>
export default {
  props: {
    disabled: {
      default: null
    }
  },
  methods: {
    insert() {
      console.log(
        document.execCommand(
          "insertHTML",
          false,
          `<a href="${prompt("链接")}">${window.getSelection()}</a>`
        )
      );
    }
  }
};
</script>

<style lang="less">
.v-editor-link {
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/editor/link.vue